import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCurrentCurrencySymbol } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCurrencyAttributes } from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import { getPriceData, getOfferPrice } from './plpTileHelpers/priceAndWishlistHelper';
import { MerchantTag, OfferPrice, StrikedThroughPrice } from './styles/PriceAndWishList.style';

import plpTileLocators from './plpTileLocators';

const Price = ({
  minListPrice,
  minOfferPrice,
  lowOfferPrice,
  highOfferPrice,
  lowListPrice,
  highListPrice,
  merchantTag,
  primaryBrand,
  currencySymbol,
  currencyAttributes,
  isBundle,
  isHideOriginalPrice,
  isShowPriceRangeEnabled,
  isTileRedesignAB,
}) => {
  const {
    offerPrice,
    listPrice,
    lowestOfferPrice,
    highestOfferPrice,
    lowestListPrice,
    highestListPrice,
    isShowListPrice,
    isShowOfferPriceRange,
    isShowListPriceRange,
  } = useMemo(
    () =>
      getPriceData({
        minListPrice,
        minOfferPrice,
        lowOfferPrice,
        highOfferPrice,
        lowListPrice,
        highListPrice,
        currencySymbol,
        currencyAttributes,
      }),
    [
      minListPrice,
      minOfferPrice,
      lowOfferPrice,
      highOfferPrice,
      lowListPrice,
      highListPrice,
      currencySymbol,
      currencyAttributes,
    ]
  );

  const showOfferPrices = useMemo(
    () =>
      getOfferPrice(
        isShowOfferPriceRange,
        isShowListPriceRange,
        lowestOfferPrice,
        highestOfferPrice,
        lowestListPrice,
        highestListPrice,
        lowOfferPrice
      ),
    [
      isShowOfferPriceRange,
      isShowListPriceRange,
      lowestOfferPrice,
      highestOfferPrice,
      lowestListPrice,
      highestListPrice,
    ]
  );

  const isShowPriceRange = () => {
    return isShowPriceRangeEnabled && (isShowOfferPriceRange || isShowListPriceRange);
  };

  const renderMerchantTag = () => {
    return merchantTag && <MerchantTag>{merchantTag}</MerchantTag>;
  };

  const renderStrikedThroughPrice = (price) => {
    return <StrikedThroughPrice>{price}</StrikedThroughPrice>;
  };

  const renderPriceList = () => {
    return (
      <>
        {renderStrikedThroughPrice(listPrice)}
        {renderMerchantTag()}
      </>
    );
  };

  const renderBundlePrice = () => {
    return (
      <>
        <div>
          {renderStrikedThroughPrice(lowestListPrice)}
          &nbsp;-&nbsp;
          {renderStrikedThroughPrice(highestListPrice)}
        </div>
        {renderMerchantTag()}
      </>
    );
  };

  return !isBundle && !isShowPriceRange() ? (
    <div
      className={`price-list${isTileRedesignAB ? ' tile-redesign' : ''}`}
      data-locator={plpTileLocators.productPrice}
    >
      <OfferPrice brand={primaryBrand}>{offerPrice}</OfferPrice>
      {listPrice !== offerPrice && !isHideOriginalPrice ? renderPriceList() : <span />}
    </div>
  ) : (
    <div
      className={`price-list bundle-price${isTileRedesignAB ? ' tile-redesign' : ''}`}
      data-locator={plpTileLocators.productPrice}
    >
      <OfferPrice brand={primaryBrand} isBundle>
        {showOfferPrices}
      </OfferPrice>
      {!isShowListPriceRange && isShowListPrice && !isHideOriginalPrice
        ? renderBundlePrice()
        : null}
    </div>
  );
};

Price.propTypes = {
  onSetLastDeletedItemIdAction: PropTypes.func.isRequired,
  minListPrice: PropTypes.number,
  minOfferPrice: PropTypes.number,
  productPartNo: PropTypes.string,
  merchantTag: PropTypes.string,
  primaryBrand: PropTypes.string,
  currencySymbol: PropTypes.string,
  currencyAttributes: PropTypes.shape({}),
  isShowPriceRangeEnabled: PropTypes.bool,
};

Price.defaultProps = {
  minListPrice: 0,
  minOfferPrice: 0,
  productPartNo: '',
  merchantTag: '',
  primaryBrand: 'tcp',
  currencySymbol: '$',
  currencyAttributes: {},
  isShowPriceRangeEnabled: false,
};

const mapStateToProps = (state) => {
  return {
    currencySymbol: getCurrentCurrencySymbol(state),
    currencyAttributes: getCurrencyAttributes(state),
  };
};

export default connect(mapStateToProps)(Price);
export { Price as PriceVanilla };
